var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useMemo } from 'react';
const initialPreviewState = {
    setPreview: () => {
        return null;
    }
};
const PreviewContext = createContext(initialPreviewState);
const PreviewProvider = function AuthProvider(_a) {
    var { previewHandler } = _a, props = __rest(_a, ["previewHandler"]);
    const value = useMemo(() => ({
        setPreview: previewHandler.setPreview
    }), [previewHandler.setPreview]);
    return React.createElement(PreviewContext.Provider, Object.assign({ value: value }, props));
};
export { PreviewProvider, PreviewContext };
//# sourceMappingURL=PreviewContext.js.map